module.exports = __webpack_public_path__ + "static/logo-a48d5797d057a08e9cedee4f0d9647d2.svg";